import Swiper from 'swiper';

const measuresSlider = document.querySelectorAll('.swiper-container.measures-slider');

const _initSlider = (sliderRoot) => {
  const slides = sliderRoot.querySelectorAll('.measure__link');
  const count = slides.length
  const lessThanThree = count < 3
  const lessThanTwo = count < 2

  const params = {
    slidesPerView: 'auto',
    centeredSlides: lessThanTwo,
    loop: !lessThanThree,
    watchOverflow: lessThanThree,
    ...(!lessThanTwo && {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets'
      },
    }),
    spaceBetween: 20,
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 3
      },
    }
  };

  const swiper = new Swiper(sliderRoot, params);
};

measuresSlider.forEach((slider) => {
  _initSlider(slider);
});

